exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputdate{margin-top:30px;border-bottom:1px solid #ccc;background-color:#eee;padding:8px;border-radius:3px;margin-right:10px}.painel-pesquisa{display:flex;justify-content:space-between}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09bba536","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/user/pxtalk/HistoricoAtendimento.vue
// module id = 996
// module chunks = 0